import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { RegularRate, overtimeFactor, overtimeRate } from 'app/models/Placement/PlacementMods';
import { isNumber } from '../../../ModificationsUtils';
import { validDecimal } from 'app/helpers/numberHelper';
import { getInvalidAmount } from '../../BillRate/HourlyRates/BillOrientation';

export const getCalculatedAmount = (getValues, factor) => {
  const helperDiv = (
    <>
      <span>(Amount = ${getValues(factor) ? (getValues(RegularRate) * getValues(factor)).toFixed(2) : '0.00'})</span>
    </>
  );

  return helperDiv;
};

export const OvertimeFactor = ({
  classes,
  currentMod,
  isModEdit,
}: {
  classes: any;
  currentMod?: string;
  isModEdit?: boolean;
}) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const overtimeFactorWatcher = useWatch<any>({ name: overtimeFactor });
  const regularRateValue = useWatch<string>({ name: RegularRate });
  const overtimeFactorValue = overtimeFactorWatcher !== 0 ? overtimeFactorWatcher : null

  return (
    <Grid className={currentMod ? null : classes.firstField}>
      <Controller
        name={overtimeFactor}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={overtimeFactorValue}
            variant="filled"
            label={`${t(`placement.placementMods.${overtimeFactor}`)}`}
            helperText={regularRateValue ? getCalculatedAmount(getValues, overtimeFactor) : getInvalidAmount()}
            className={currentMod ? classes.billFactorTextfields : classes.factorTextfields}
            InputLabelProps={{
              shrink: getValues(overtimeFactor),
            }}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 3, decimalLength: 2 })) {
                onChange(e.target.value);
                setValue(overtimeFactor, e.target.value);
                setValue(overtimeRate, '');
              }
            }}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>
                  {isNumber(overtimeFactorValue) && (
                    <InputAdornment position="start">
                      <CloseIcon className={classes.iconClass} />
                    </InputAdornment>
                  )}
                </>
              ),
            }}
            {...rest}
          />
        )}
      />
    </Grid>
  );
};
